/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queues_Your_TurnInputs */

const en_queues_your_turn = /** @type {(inputs: Queues_Your_TurnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your turn`)
};

/**
* | output |
* | --- |
* | "Your turn" |
*
* @param {Queues_Your_TurnInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queues_your_turn = /** @type {((inputs?: Queues_Your_TurnInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queues_Your_TurnInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queues_your_turn(inputs)
});